import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function RouteFocus() {
  const { pathname } = useLocation();
  const initialPath = useRef(true);

  useEffect(() => {
    if (initialPath.current) {
      initialPath.current = false;
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    let focusFrame = 0;
    const routeFrame = window.requestAnimationFrame(() => {
      focusFrame = window.requestAnimationFrame(() => {
        const main = document.querySelector<HTMLElement>("main");
        if (!main) return;
        main.tabIndex = -1;
        main.focus({ preventScroll: true });
      });
    });
    return () => {
      window.cancelAnimationFrame(routeFrame);
      window.cancelAnimationFrame(focusFrame);
    };
  }, [pathname]);

  return null;
}
